<template>
    <button class="p-1 rounded-full text-gray-400 hover:text-indigo-500 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-slate-900 hover:shadow-sm focus:text-indigo-500 focus:bg-gray-100 focus:shadow-sm" @click.prevent="close">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path d="M6 18L18 6M6 6l12 12" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
        </svg>
    </button>
</template>

<script>
export default {
    methods: {
        close() {
            this.$emit("close")
        },
    },
}
</script>
